import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { showBetslip } from 'right-sidebar';
import { fetch } from 'betslip-services';

export default () => {
  useEffect(() => {
    fetch({ force: true }).then(showBetslip);
  }, []);

  return <Redirect to="/" />;
};
